const B_1 = [
    {
        title: '中标/招标结果通知审核',
        path: '/manage/business/audittzs/list'
    }
]

export default {
    path: 'audittzs',
    component: () => import(/*webpackChunkName: 'business-auditzs'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import('@views/manage/views/business/audit-tzs/list'),
            meta: {
                title: '中标/招标结果通知审核',
                topNav: true,
                bread: B_1
            },
        },
        {
            path:"detail",
            component: () => import('@views/manage/views/business/audit-tzs/detail'),
            meta: {
                title: '中标/招标结果通知审核详情',
                bread: B_1
            },
        },
    ]
}
